module.exports = __webpack_public_path__ + "img/edit-disabled.65197473.svg";